import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';

var firebaseConfig = {
    apiKey: "AIzaSyAgqV-z4Qbl2nKcKrynAzGymaNkv5HqoMI",
    authDomain: "image-bucket-e6ccf.firebaseapp.com",
    projectId: "image-bucket-e6ccf",
    storageBucket: "image-bucket-e6ccf.appspot.com",
    messagingSenderId: "855095723612",
    appId: "1:855095723612:web:c69e113fd6300f8c5fc899",
    measurementId: "G-6VC2485NP0"
  };

//initialize firebase
firebase.initializeApp(firebaseConfig);

const imageStorage = firebase.storage();
const imageFirestore = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { imageStorage, imageFirestore, timestamp };